//Note: Only Update the image url here to change images. 
import img4 from "../assets/ads photos/images/553560431_807502415085726_1815307910232547977_n.jpg";
import img5 from "../assets/ads photos/images/553705596_804450612165622_2905364908665163807_n.jpg";
import img6 from "../assets/ads photos/images/553884764_1458136712083689_4366360947409749198_n.jpg";
import img7 from "../assets/ads photos/images/553969098_2106368623233208_6071212848546601420_n.jpg";
import img8 from "../assets/ads photos/images/554167969_768286699341569_6605751448021367138_n.jpg";
import img9 from "../assets/ads photos/images/554199100_1506460704136383_319090712202236020_n.jpg";
import img10 from "../assets/ads photos/images/556884807_813125714389590_8181652237997690355_n.jpg";
export const galleryItems = [
  {
    id: "1",
    img: img4,
    url: "https://example.com/one",
    height: 400,
  },
  {
    id: "2",
    img: img5,
    url: "https://example.com/two",
    height: 250,
  },
  {
    id: "3",
    img: img6,
    url: "https://example.com/three",
    height: 600,
  },
  {
    id: "4",
    img: img4,
    url: "https://example.com/four",
    height: 350,
  },
  {
    id: "5",
    img: img5,
    url: "https://example.com/five",
    height: 500,
  },
  {
    id: "6",
    img: img6,
    url: "https://example.com/six",
    height: 450,
  },
  {
    id: "7",
    img: img7,
    url: "https://example.com/seven",
    height: 300,
  },
  {
    id: "8",
    img: img8,
    url: "https://example.com/eight",
    height: 550,
  },
  {
    id: "9",
    img: img9,
    url: "https://example.com/nine",
    height: 380,
  },
  {
    id: "10",
    img: img10,
    url: "https://example.com/ten",
    height: 420,
  },
];